import { CenteredLayout } from "@/components/layouts/centered-layout";
import { Skeleton } from "@/components/ui/skeleton";

export function RelocationOrderDetailSkeleton() {
  return (
    <CenteredLayout className="md:max-w-5xl">
      <div className="flex flex-col gap-6">
        <Skeleton className="h-8 w-80" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-48 w-full rounded-lg" />
        <Skeleton className="h-64 w-full rounded-lg" />
        <Skeleton className="h-72 w-full rounded-lg" />
      </div>
    </CenteredLayout>
  );
}
